import classNames from "classnames";
import React, { useCallback, useState } from "react";
import { useAppDispatch } from "../../../../../state/store";
import { hideDataSyncFinishedAction } from "../../../../../state/usecase/admin/care_recipient/actions";

export const CareRecipientsHideSwitch = React.memo(function CareRecipientsHideSwitch() {
    const dispatch = useAppDispatch();

    const [hideDataSyncFinished, setHideDataSyncFinished] = useState(false);

    const handleHideDataSyncFinishedButtonClicked = useCallback(()  => {
        setHideDataSyncFinished(prev => !prev);

        dispatch(
            hideDataSyncFinishedAction({ hideDataSyncFinished: !hideDataSyncFinished })
        );
    }, [dispatch, hideDataSyncFinished]);

    return (
        <div className={"hideDataSyncFinished_area"}>
            <div className={"hideDataSyncFinishedButton_title"}>データ連携終了者を非表示にする:</div>
            <div className={classNames("switch", { on: hideDataSyncFinished })} onClick={handleHideDataSyncFinishedButtonClicked}></div>
        </div>
    );
});